<template>
  <div class="header row fixed-top download-top" v-if="show">
    <div class="flex cc">
      <span class="f16">下载草莓APP</span>
      <span class="f13">海量精品小说抢先看</span>
    </div>
    <p class="cc">
      <a class="cc" :href="getCommonInfo.appDownloadUrl" target="_blank">下载APP</a>
    </p>
    <a class="btn" @click.stop="show=false">关闭</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'download',
  data () {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['getCommonInfo'])
  },
  methods: {
    isAndroid () {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
      return isAndroid
    }
  },
  created () {
    const isAndroid = this.isAndroid()
    if (isAndroid) {
      this.show = true
    }
  }
}
</script>
<style lang="less" scoped>
  .download-top{
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;

  }
</style>
